import { __extends } from "tslib";
import { DirectionalShadowMapper, _Shader_DirectionalShadowMapper } from './DirectionalShadowMapper';
var NearDirectionalShadowMapper = /** @class */ (function (_super) {
    __extends(NearDirectionalShadowMapper, _super);
    function NearDirectionalShadowMapper(image2D, coverageRatio, fadeRatio) {
        if (image2D === void 0) { image2D = null; }
        if (coverageRatio === void 0) { coverageRatio = .5; }
        if (fadeRatio === void 0) { fadeRatio = .1; }
        var _this = _super.call(this, image2D) || this;
        _this.coverageRatio = coverageRatio;
        _this._fadeRatio = fadeRatio;
        return _this;
    }
    Object.defineProperty(NearDirectionalShadowMapper.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return NearDirectionalShadowMapper.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NearDirectionalShadowMapper.prototype, "coverageRatio", {
        /**
         * A value between 0 and 1 to indicate the ratio of the view frustum that needs to be covered by the shadow map.
         */
        get: function () {
            return this._coverageRatio;
        },
        set: function (value) {
            if (value > 1)
                value = 1;
            else if (value < 0)
                value = 0;
            this._coverageRatio = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NearDirectionalShadowMapper.prototype, "fadeRatio", {
        /**
         * The amount of shadow fading to the outer shadow area. A value of 1 would mean the shadows start fading from the camera's near plane.
         */
        get: function () {
            return this._fadeRatio;
        },
        set: function (value) {
            this._fadeRatio = value;
        },
        enumerable: true,
        configurable: true
    });
    NearDirectionalShadowMapper.prototype._updateProjection = function (projection) {
        var corners = projection.viewFrustumCorners;
        for (var i = 0; i < 12; ++i) {
            var v = corners[i];
            this._localFrustum[i] = v;
            this._localFrustum[i + 12] = v + (corners[i + 12] - v) * this._coverageRatio;
        }
        this._updateProjectionFromFrustumCorners(projection, this._localFrustum, this._matrix);
        this._overallDepthProjection.frustumMatrix3D = this._matrix;
    };
    NearDirectionalShadowMapper.assetType = '[asset NearDirectionalShadowMapper]';
    return NearDirectionalShadowMapper;
}(DirectionalShadowMapper));
export { NearDirectionalShadowMapper };
import { ShaderBase } from '@awayjs/renderer';
// TODO: shadow mappers references in materials should be an interface so that this class should NOT extend ShadowMapMethodBase just for some delegation work
/**
 * ShadowNearChunk provides a shadow map method that restricts the shadowed area near the camera to optimize
 * shadow map usage. This method needs to be used in conjunction with a NearDirectionalShadowMapper.
 *
 * @see away.lights.NearDirectionalShadowMapper
 */
var _Shader_NearDirectionalShadowMapper = /** @class */ (function (_super) {
    __extends(_Shader_NearDirectionalShadowMapper, _super);
    function _Shader_NearDirectionalShadowMapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    _Shader_NearDirectionalShadowMapper.prototype._initConstants = function () {
        _super.prototype._initConstants.call(this);
        var fragmentData = this._shader.fragmentConstantData;
        var index = this._fragmentDistanceIndex;
        fragmentData[index + 2] = 0;
        fragmentData[index + 3] = 1;
    };
    /**
     * @inheritDoc
     */
    _Shader_NearDirectionalShadowMapper.prototype._initVO = function (chunkVO) {
        _super.prototype._initVO.call(this, chunkVO);
        chunkVO.needsProjection = true;
    };
    /**
     * @inheritDoc
     */
    _Shader_NearDirectionalShadowMapper.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = _super.prototype._getFragmentCode.call(this, targetReg, registerCache, sharedRegisters);
        var dataReg = registerCache.getFreeFragmentConstant();
        var temp = registerCache.getFreeFragmentSingleTemp();
        this._fragmentDistanceIndex = dataReg.index * 4;
        code += 'abs ' + temp + ', ' + sharedRegisters.projectionFragment + '.w\n' +
            'sub ' + temp + ', ' + temp + ', ' + dataReg + '.x\n' +
            'mul ' + temp + ', ' + temp + ', ' + dataReg + '.y\n' +
            'sat ' + temp + ', ' + temp + '\n' +
            'sub ' + temp + ', ' + dataReg + '.w,' + temp + '\n' +
            'sub ' + targetReg + '.w, ' + dataReg + '.w,' + targetReg + '.w\n' +
            'mul ' + targetReg + '.w, ' + targetReg + '.w, ' + temp + '\n' +
            'sub ' + targetReg + '.w, ' + dataReg + '.w,' + targetReg + '.w\n';
        return code;
    };
    /**
     * @inheritDoc
     */
    _Shader_NearDirectionalShadowMapper.prototype._setRenderState = function (renderState) {
        // todo: move this to activate (needs camera)
        var near = this._shader.view.projection.near;
        var d = this._shader.view.projection.far - near;
        var maxDistance = this._mapper.coverageRatio;
        var minDistance = maxDistance * (1 - this._mapper.fadeRatio);
        maxDistance = near + maxDistance * d;
        minDistance = near + minDistance * d;
        var fragmentData = this._shader.fragmentConstantData;
        var index = this._fragmentDistanceIndex;
        fragmentData[index] = minDistance;
        fragmentData[index + 1] = 1 / (maxDistance - minDistance);
        _super.prototype._setRenderState.call(this, renderState);
    };
    return _Shader_NearDirectionalShadowMapper;
}(_Shader_DirectionalShadowMapper));
export { _Shader_NearDirectionalShadowMapper };
ShaderBase.registerAbstraction(_Shader_NearDirectionalShadowMapper, NearDirectionalShadowMapper);
